module.exports = __webpack_public_path__ + "static/media/logo_apjii.6f5a1902.png";